export default __webpack_public_path__ + "static/screen_history-29bb827ac1291f8c932d4f9d9d2c5bf9.jpg";